import { User } from "../../../auth/types";
import { httpWebApi } from "../../../../core/http/httpThunks";

export const printPayment = (user: User, payid: string) => {
	return httpWebApi<Blob>({
		method: "GET",
		responseType: "blob",
		timeout: 60 * 4 * 1000,
		url: "reporting/getpaymentconfreport",
		params: {
			userid: user.userId,
			payid,
		},
	});
};

export default printPayment;
